import { api } from "@/lib/api";
import { createCompletion } from "@/lib/appointment-completion";
import { createMarkDone } from "@/lib/appointment-mark-done";
import type { uuid } from "@/interfaces";
import { toAppointmentJoin } from "@/repositories/appointment-records";
import { activeOrganization, type AppointmentJoin } from "@/repositories/appointments.repository";

const complete = createCompletion(api.appointments);

export async function completeAppointment(id: uuid, reason?: string): Promise<AppointmentJoin> {
  return toAppointmentJoin(await complete(id, { reason, actingOrganization: activeOrganization() }));
}

const markDone = createMarkDone(api.appointments);

export async function markAppointmentDone(id: uuid): Promise<AppointmentJoin> {
  return toAppointmentJoin(await markDone(id, activeOrganization()));
}
